import { Switch } from "@/components/ui/switch";
import { Tone } from "@/components/shared";

export function PermissionList({ catalog, isOn, onToggle, isOverride, disabled, testid = "perm" }) {
  const groups = [...new Set(catalog.map((c) => c.group))];
  return (
    <div className="space-y-5">
      {groups.map((g) => (
        <div key={g}>
          <div className="text-[11px] font-semibold uppercase tracking-wider text-muted-foreground mb-2">{g}</div>
          <div className="rounded-lg border divide-y">
            {catalog.filter((c) => c.group === g).map((c) => (
              <label key={c.action} className="flex items-center gap-3 px-4 py-2.5 text-sm cursor-pointer">
                <div className="flex-1 min-w-0">
                  <div>{c.label}</div>
                  <div className="text-[11px] text-muted-foreground font-mono">{c.action}</div>
                </div>
                {isOverride?.(c.action) && <Tone tone="purple" data-testid={`${testid}-override-${c.action}`}>Override</Tone>}
                <Switch checked={isOn(c.action)} disabled={disabled} onCheckedChange={(v) => onToggle(c.action, v)} data-testid={`${testid}-${c.action}`} />
              </label>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
